import { InputProps, TextInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { PatternFormat } from "react-number-format";

interface newValues {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TelInput = (properties: InputProps | newValues) => {
  const [format, setFormat] = useState<string>("(##) #####-####");

  // Detecta o formato baseado no valor atual
  useEffect(() => {
    const currentValue = "value" in properties ? properties.value : "";
    if (currentValue) {
      const numbers = currentValue.replaceAll(/\D/g, "");

      // Se o 3º dígito é 9, é celular
      if (numbers.length >= 3 && numbers[2] === "9") {
        setFormat("(##) #####-####");
      } else if (numbers.length === 10) {
        setFormat("(##) ####-####");
      } else if (numbers.length === 11) {
        setFormat("(##) #####-####");
      }
    }
  }, ["value" in properties ? properties.value : ""]);

  const handleValueChange = (values: any) => {
    const numbers = values.value.replaceAll(/\D/g, "");

    // Detecta o formato enquanto digita
    if (numbers.length >= 3 && numbers[2] === "9") {
      setFormat("(##) #####-####");
    } else if (numbers.length <= 10) {
      setFormat("(##) ####-####");
    } else {
      setFormat("(##) #####-####");
    }
  };

  return (
    <PatternFormat
      customInput={TextInput}
      type="tel"
      format={format}
      mask="_"
      allowEmptyFormatting
      onValueChange={handleValueChange}
      {...properties}
    />
  );
};

export default TelInput;
